import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import EIDModal from './EIDModal/EIDModal';
const NemAdgangButton = ({ icon, title, target, text = null, classes = null }) => {
    const [showModal, toggleModal] = useState(false);
    return (_jsxs("div", { children: [showModal && (_jsx(EIDModal, { redirect: target, closeModal: () => toggleModal(false) })), _jsxs("button", Object.assign({ className: classes, type: 'button', onClick: () => toggleModal(true) }, { children: [icon && _jsx("i", { className: `far ${icon}`, title: title }), text && text] }))] }));
};
NemAdgangButton.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    target: PropTypes.string,
    text: PropTypes.string,
    classes: PropTypes.string
};
export default NemAdgangButton;
